import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { Dialog, Typography } from '@material-ui/core';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import ProductOverviewVideo1Thumbnail from '@assets/product-overview-video-1-thumbnail-new.png';
import ProductOverviewVideo2Thumbnail from '@assets/product-overview-video-3-thumbnail-new.png';
import ProductOverviewVideo3Thumbnail from '@assets/product-overview-video-2-thumbnail-new.png';
import CourierOverviewVideo1Thumbnail from '@assets/courier-overview-video-1-thumbnail-new.png';
import CourierOverviewVideo2Thumbnail from '@assets/courier-overview-video-2-thumbnail-new.png';
import CourierOverviewVideo3Thumbnail from '@assets/courier-overview-video-3-thumbnail-new.png';
import PlayButtonImage from '@assets/play-button.png';
import { PAGE_TYPE } from '../..';
import YouTube from 'react-youtube';
import { useTranslation } from 'react-i18next';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { trackVideoClose, trackVideoInplay, trackVideoPause, trackVideoStart } from '../../tracking/productoverview/video';
import i18n from '@src/i18n';

interface TutorialVideo {
  title: string;
  videoId: string;
  thumbnailImage: string;
}

let percentageCache = [] as Array<Number>;
const HowItWorksContent = (props: any) => {
  const classes = useStyles();
  const [currentVideoId, setCurrentVideoId] = useState('');
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [currentActiveVideoOrder, setCurrentActiveVideoOrder] = useState(0); //This variable will be used for anayltics.
  const [currentVideoContext, setCurrentVideoContext] = useState(null);
  const { isMobileDevice,isResolutionMobile } = useDeviceDetect();
  const { t } = useTranslation();
  const videoOptions = {
    width: (isResolutionMobile ? '100%' : '640px'),
    height: '480px',
    playerVars: {
      autoplay: 1,
    },
  };

  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode:true,
    centerPadding: isMobileDevice ? "45px" : undefined,
  };

  const managerTutorialVideos: Array<TutorialVideo> = [
    {
      title: t('new_productoverview_manager.video_1_description'),
      videoId: t('new_productoverview_manager.video_1_id'),
      thumbnailImage: ProductOverviewVideo1Thumbnail,
    },
    {
      title: t('new_productoverview_manager.video_2_description'),
      videoId: t('new_productoverview_manager.video_2_id'),
      thumbnailImage: ProductOverviewVideo2Thumbnail,
    },
    {
      title: t('new_productoverview_manager.video_3_description'),
      videoId: t('new_productoverview_manager.video_3_id'),
      thumbnailImage: ProductOverviewVideo3Thumbnail,
    },
  ];

  const courierTutorialVideos: Array<TutorialVideo> = [
    {
      title: t('new_productoverview_courier.video_1_description'),
      videoId: t('new_productoverview_courier.video_1_id'),
      thumbnailImage: CourierOverviewVideo1Thumbnail,
    },
    {
      title: t('new_productoverview_courier.video_2_description'),
      videoId: t('new_productoverview_courier.video_2_id'),
      thumbnailImage: CourierOverviewVideo2Thumbnail,
    },
    {
      title: t('new_productoverview_courier.video_3_description'),
      videoId: t('new_productoverview_courier.video_3_id'),
      thumbnailImage: CourierOverviewVideo3Thumbnail,
    },
  ];

  const tutorialVideos: Array<TutorialVideo> =
  props.pageType === PAGE_TYPE.MANAGER
    ? managerTutorialVideos
    : courierTutorialVideos;

  const handleDialogClose = () => {
    setDialogIsOpen(false);
    videoOnCloseHandler();
    setCurrentVideoId('');
    setCurrentVideoContext(null);
  };
  const videoOnCloseHandler = () => {
    if (currentVideoContext) {
      const { title: video_title } = (
        currentVideoContext as any
      )?.target?.getVideoData();
      trackVideoClose(`VIDEO_${currentActiveVideoOrder}`, video_title, i18n.language)
    }
  };
  const videoOnPlayHandler = (videoContext: any) => {
    const videoInfo = videoContext?.target?.getVideoData() || {};
    setCurrentVideoContext(videoContext);
    const { title: video_title } = videoInfo;
    trackVideoStart(`VIDEO_${currentActiveVideoOrder}`, video_title, i18n.language)
  };
  const videoOnPauseHandler = ({ target: videoContext }: any) => {
    percentageCache = [];
    const videoInfo = videoContext?.getVideoData() || {};
    const { title: video_title } = videoInfo;
    trackVideoPause(`VIDEO_${currentActiveVideoOrder}`, video_title, i18n.language)
  };
  const videoInplayHandler = () => {
    if (currentVideoContext) {
      const context = currentVideoContext as any
      const { title: video_title } = context?.target?.getVideoData()
      const currentVideoTime = context?.target?.getCurrentTime()
      const videoDuration = context?.target?.getDuration()
      const usedPercentageList = trackVideoInplay(`VIDEO_${currentActiveVideoOrder}`, video_title, i18n.language, currentVideoTime, videoDuration, percentageCache)
      if (usedPercentageList) {
        percentageCache = usedPercentageList
      }
    }
  };
  const openVideo = (videoId: string, videoOrder: number) => {
    percentageCache = [];
    setCurrentVideoId(videoId);
    setDialogIsOpen(true);
    setCurrentActiveVideoOrder(videoOrder);
  };

  const populateVideos = () => {
    return tutorialVideos.map((video, index) => {
      return (
        <div
          key={index}
          className="howitworks-video-item"
          onClick={() => openVideo(t(video.videoId), index + 1)}
        >
          <img src={PlayButtonImage} className={'play-button'} />
          <img src={video.thumbnailImage} />
          <Typography
            variant="body1"
            className="body_regular"
            align="center"
          >
            {video.title}
          </Typography>
        </div>
      );
    })
  }

  useEffect(() => {
    if (currentVideoContext) {
      const videoPercentageDetectTimer = setInterval(() => {
        videoInplayHandler();
      }, 100);
      return () => {
        clearTimeout(videoPercentageDetectTimer);
      };
    }
  }, [currentVideoContext]);
  return (
    <div className={classes.howItWorksContent}>
      <Dialog
        onClose={handleDialogClose}
        open={dialogIsOpen}
        className="videoDialog"
      >
        <YouTube
          opts={videoOptions}
          videoId={currentVideoId}
          onEnd={handleDialogClose}
          onPlay={videoOnPlayHandler}
          onPause={videoOnPauseHandler}
        />
      </Dialog>
      <Typography
        variant={`${isResolutionMobile ? 'h3' : 'h1'}`}
        className={`${isResolutionMobile ? 'heading_l' : 'heading_xxl'} howitworks-title`}
        align="center"
      >
        <JetFontIcon
          className="title-icon"
          iconname={JET_FONTICON_ALIASES.PLAY}
          size={isResolutionMobile ? 16 : 33}
        />{' '}
        {props.pageType === PAGE_TYPE.MANAGER ? t('new_productoverview_manager.section5_title') :  t('new_productoverview_courier.section5_title')}
      </Typography>
      <Typography
        className="body_regular howitworks-description"
        variant="body1"
        align="center"
      >
        {props.pageType === PAGE_TYPE.MANAGER ? t('new_productoverview_manager.section5_description') :  t('new_productoverview_courier.section5_description')}
      </Typography>
      <div className="howitworks-videos-container">
        { isResolutionMobile ? <Slider {...carouselSettings}>{populateVideos()}</Slider> : populateVideos() }
      </div>
    </div>
  );
};

export default HowItWorksContent;
